import { z } from 'zod';
import { paginationQuerySchema } from '../common/envelope.js';
export const inviteUserSchema = z.object({
    email: z.string().trim().toLowerCase().email(),
    displayName: z.string().trim().min(1).max(150),
    jobTitle: z.string().trim().max(150).optional(),
    roleIds: z.array(z.string().uuid()).min(1),
    teamIds: z.array(z.string().uuid()).default([]),
});
export const updateMembershipSchema = z.object({
    jobTitle: z.string().trim().max(150).optional(),
    roleIds: z.array(z.string().uuid()).min(1).optional(),
    teamIds: z.array(z.string().uuid()).optional(),
});
export const listMembershipsQuerySchema = paginationQuerySchema.extend({
    status: z.enum(['invited', 'active', 'deactivated', 'removed']).optional(),
});
export const membershipResponseSchema = z.object({
    id: z.string().uuid(),
    userId: z.string().uuid(),
    email: z.string().email(),
    displayName: z.string(),
    jobTitle: z.string().nullable(),
    // `removed` is a soft delete — set by `DELETE /admin/users/:id` when a
    // hard delete isn't safe (see `deletable` below). Gated out of
    // login/sessions/JIT-link exactly like `deactivated`, since every one of
    // those checks is an allow-list on `status === 'active'`.
    status: z.enum(['invited', 'active', 'deactivated', 'removed']),
    roles: z.array(z.object({ id: z.string().uuid(), name: z.string() })),
    teams: z.array(z.object({ id: z.string().uuid(), name: z.string() })),
    lastActiveAt: z.string().datetime().nullable(),
    invitedAt: z.string().datetime(),
    /** How this membership came to exist — invited by an admin, or
     * just-in-time provisioned the first time they signed in via SSO. */
    signupSource: z.enum(['invited', 'sso']),
    /** Whether `DELETE /admin/users/:id` would permanently delete this user
     * (true — they own no record and appear in no activity/audit history) or
     * just soft-delete them to `removed` (false — those relations are
     * FK-protected against a hard delete). */
    deletable: z.boolean(),
    blockingRecordCount: z.number().int(),
});
export const deleteMembershipResponseSchema = z.object({
    mode: z.enum(['hard', 'soft']),
    membership: membershipResponseSchema.nullable(),
});
//# sourceMappingURL=users.js.map